import React, { Component } from "react";
import styles from "./LoginForm.styles";
import messages from "./LoginForm.messages";

type Props = {
  onRequestLogin: () => void,
};

type State = {
  email: string,
  password: string,
};

export default class LoginForm extends Component {
  props: Props;

  state: State = {
    email: "",
    password: "",
  };

  constructor(props: Props) {
    super(props);
  }

  componentDidMount() {}

  handleEmailChange = (event) => {
    this.setState({ email: event.target.value });
  };

  handlePasswordChange = (event) => {
    this.setState({ password: event.target.value });
  };

  //TODO FIXME return form errors when invalid email (or password)
  //TODO FIXME add loading symbol after clicking login
  handleLogin = (event) => {
    event.preventDefault();
    this.loginPromise = Promise.resolve(this.doLogin());
  };

  async doLogin() {
    await this.props.onRequestLogin({
      email: this.state.email,
      password: this.state.password,
    });
  }

  render() {
    return (
      <form onSubmit={this.handleLogin}>
        <div className="form-group sign-inup">
          <input
            className="form-control"
            type="email"
            name={messages.email}
            style={styles.input}
            placeholder={messages.email}
            onChange={this.handleEmailChange}
          />
        </div>
        <div className="form-group sign-inup">
          <input
            className="form-control"
            type="password"
            name={messages.password}
            style={styles.input}
            placeholder={messages.password}
            onChange={this.handlePasswordChange}
          />
        </div>
        <button
          type="submit"
          onClick={this.handleLogin}
          bsStyle="primary"
          className="jr-btn btn btn-primary m-b-15 sign-inup-submit-btn"
        >
          {messages.login}
        </button>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/forms/login-form/LoginForm.js